import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "../ErrorBoundary";
import { ToastContainer } from "../Toast";
import { ConfirmDialogHost } from "../ConfirmModal";
import { AppRibbon } from "./AppRibbon";
import { Breadcrumb } from "./Breadcrumb";
import { ShortcutHelp } from "./ShortcutHelp";

/** Ribbon, breadcrumb, 1400px content container, toasts, confirm host, shortcut help. */
export function AppShell() {
  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      <AppRibbon />
      <Breadcrumb />
      <main id="main-content" className="mx-auto w-full max-w-[1400px] p-6">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <ToastContainer />
      <ConfirmDialogHost />
      <ShortcutHelp />
    </div>
  );
}
